<template>
  <div class="home">

    <v-container fluid>
      <v-layout wrap align-center justify-center row fill-height style="min-height: 80vh;">

        <v-flex lg5 md6 xs12 class="hero pl-5 pr-5">
          <h1 class="indigo--text text--darken-3">Altcoins on Autopilot</h1>
          <h3>The simple way to grow your altcoin portfolio like the world’s most sophisticated investors.</h3>

          <v-btn block dark color="secondary" class="mt-5" href="https://turingform.com/view/f_77ff2e20830811e986b5cb40db5b1e68">Get Private Access</v-btn>
        </v-flex>

        <v-flex lg4 md6 xs12 mt-5>
          <v-img
          :src="require('../assets/undraw_taking_notes.svg')"
          contain
          ></v-img>
        </v-flex>

      </v-layout>

    </v-container>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {
  }
}
</script>

<style scoped>

h1 {
  font-family: 'Lora', serif;
}

h3 {
  font-family: 'Open Sans', sans-serif;
}

.hero {
  margin-top:80px;
}

</style>
